export enum PageType {
  LandingPage = "LandingPage",
  PortfolioAnalysis = "PortfolioAnalysis",
  Playground = "Playground",
  OneClick = "OneClick",
  BackOfficeUser = "BackOfficeUser",
  BackOfficeInstitution = "BackOfficeInstitution",
  BackOfficeSubscription = "BackOfficeSubscription",
  BackOfficeUserHistory = "BackOfficeUserHistory",
  BackOfficeIndices = "BackOfficeIndices",
}
